import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { PlatformDetectionService } from '../platform-detection.service';

@Injectable({
	providedIn: 'root',
})
export class PWAGuardService {
	constructor(
		private router: Router,
		private platformDetection: PlatformDetectionService
	) {}

	canActivate(): boolean {
		if (this.platformDetection.is('pwa')) {
			console.log('PWA Guard: PWA detected');
			return true;
		}

		console.log('PWA Guard: Not in PWA mode, redirecting to home');
		this.router.navigate(['/home']);
		return false;
	}
}
